import { render, staticRenderFns } from "./SsnAnswer.vue?vue&type=template&id=7d20874c&"
import script from "./SsnAnswer.vue?vue&type=script&lang=js&"
export * from "./SsnAnswer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports